import script from "./FormSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormSummary.vue?vue&type=script&setup=true&lang=ts"

import "./FormSummary.vue?vue&type=style&index=0&id=670fbfab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-670fbfab"]])

export default __exports__